module.exports = "/images/defaultCircle.svg?f7e08b9ee7d0432bcc9eb87c18d32f5f";